/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type { GroundingMenuItemSkeletonState, GroundingMenuItemSkeletonSlots } from './GroundingMenuItemSkeleton.types';

/**
 * Render the final JSX of GroundingMenuItemSkeleton
 */
export const renderGroundingMenuItemSkeleton_unstable = (state: GroundingMenuItemSkeletonState): JSXElement => {
  assertSlots<GroundingMenuItemSkeletonSlots>(state);

  return (
    <state.root>
      {state.avatar && <state.avatar />}
      {state.primaryText && <state.primaryText />}
      {state.secondaryText && <state.secondaryText />}
    </state.root>
  );
};
